import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import {
  extendWidth,
  flex,
  flexDirectionColumn,
  SPACE_COMPACT,
  SPACE_COZY,
  SPACE_MINIMUM,
  SPACE_RELAXED,
  SPACE_TINY,
} from '@/styles';

export const labelSelectedStyles = css`
  font-weight: 600;
`;
export const labelSelectedTitleStyles = css`
  font-weight: 400;
`;

export const advancedDropdownMenuStyles = css`
  ${flex};
  ${flexDirectionColumn};
  position: relative;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    overflow-y: auto;
    padding-bottom: ${SPACE_COMPACT}px;
    margin-top: ${SPACE_TINY}px;

    li {
      label {
        width: 100%;
        svg {
          transition: none;
        }
        input {
          transition: none;
          &:focus,
          &:focus:checked {
            outline: none;
          }
        }
      }
      min-height: ${SPACE_RELAXED}px;
      padding: 0 ${SPACE_COZY}px;
      display: flex;
      align-items: center;

      &:hover {
        background-color: ${token('color.background.accent.gray.subtlest')};
        box-shadow: inset 2px 0 0 ${token('color.border.focused')};
      }
    }
  }
`;

export const advancedDropdownSearchStyles = css`
  padding: ${SPACE_COMPACT}px;
  i {
    padding: ${SPACE_MINIMUM}px;
    cursor: pointer;
  }
`;

export const clearFilterStyles = css`
  background-color: ${token('color.text.inverse')};
  border-top: 1px solid ${token('color.background.neutral.subtle.pressed')};
  padding: 10px 12px;
  ${extendWidth};
  cursor: pointer;
  margin-top: auto;
  &:hover {
    background-color: ${token('color.background.input.hovered')};
  }
`;

export const secondaryTextStyles = css`
  color: ${token('color.text.disabled')};
`;
